// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tUuf","colBig":"styles_colBig__3tuAx","colSmall":"styles_colSmall__2vO7z"};